const ModalRentalDiscontinued = (props) => {
  return (
    <div className="bg-white px-[20px] max-w-[640px] max-h-[90vh] overflow-y-auto">
      <div className="flex flex-col gap-[20px] py-[50px]">
        <div className="text-[32px] font-bold">
          {`패션 대여 서비스를 종료합니다.`}
        </div>
        <div className="text-[14px] whitespace-pre-wrap">
          {
            `안녕하세요, 오늘룩입니다.\n\n` +
            `오늘룩 패션 대여 서비스가 2025년 9월 26일부로 종료됩니다.\n` +
            `이에 따라 인플루언서 대여가 중단되며, 브랜드의 신규 제품 등록 또한 불가능합니다.\n\n` +
            `현재 대여 중인 제품은 전부 회수 완료 후 각 브랜드의 주소지로 반납을 진행할 예정이며,\n` +
            `반납 직전 주소지 확인을 위해 개별적으로 연락을 드릴 예정입니다.\n\n` +
            `- 반납 예정 기한 : 2025년 10월 31일\n` +
            `- 9월 결제분 2025년 10월 15일에 정상적으로 결제 진행될 예정\n\n` +
            `만약 반납을 원치 않으시는 경우,\n` +
            `미혼모 플리마켓에 기부 가능하오니 단톡방을 통해 알려주시기 바랍니다.`
          }
        </div>
        <div className="flex flex-col justify-center mx-auto items-center gap-[10px]">
          <img className="max-w-[320px]" src={`/assets/images/temp/rent-agreement.png`}></img>
        </div>
        <div className="text-[14px] whitespace-pre-wrap text-[#FF0000]">
          {
            `한 가지 다시 한 번 강조드립니다.\n\n` +
            `오늘룩 패션 대여 서비스는 시작 시점에 인플루언서의 귀책사유 및 물류 운영 과정 등 모든 범위에서 파손/분실 시 오늘룩은 배상 책임을 지지 않음에 동의하신 후 이용이 개시되었습니다.\n\n` +
            `따라서 이용 과정에서 발생한 모든 파손/분실 건은 이미 귀하의 동의 하에 면책이 확정된 사안으로, 어떠한 경우에도 이의 제기나 책임 요구는 불가합니다.\n\n` +
            `이 점에 대해 절대적인 효력이 있음을 다시 한 번 명확히 고지합니다.`
          }
        </div>
        <div className="text-[14px] whitespace-pre-wrap">
          {
            `그동안 오늘룩 패션대여 서비스를 이용해 주셔서 감사합니다.\n\n`+
            `오늘룩 드림`
          }
        </div>
      </div>

      <div className="w-full flex flex-col pb-[50px]">
        <div
          className="flex justify-center items-center w-[280px] h-12 bg-black mx-auto cursor-pointer"
          onClick={props.closeModal}
        >
          <div className="text-center text-white text-[17px] font-bold">
            {`확인`}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalRentalDiscontinued
